import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { SearchCatalogKey } from './search.i18n.js';
import { SEARCH_CATALOG } from './search.i18n.js';

export type SearchMessageId = `search:${SearchCatalogKey}`;

const PREFIX_LENGTH = 'search:'.length;

/** `t()` for the stop-gap `search:` scope (see `search.i18n.ts`). */
export function useSearchT(): { t: (id: SearchMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: SearchMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as SearchCatalogKey;
      const raw = SEARCH_CATALOG[locale][key] ?? SEARCH_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
